module.exports = __webpack_public_path__ + "static/media/fall.a359fd0.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/fall.wav
// module id = 151
// module chunks = 1